<template>
  <div :class="{ container: screenSize.desktop, 'ls-leads-inbox': !screenSize.desktop }">
    <BLoading :active.sync="isLoading" />
    <div v-if="!isLoading" class="columns is-mobile">
      <Transition name="inbox">
        <div
          v-if="(!screenSize.desktop && isInbox) || screenSize.desktop"
          :class="[
            'column ls-leads-inbox--left',
            { 'is-4': screenSize.desktop, 'is-12': !screenSize.desktop },
          ]"
        >
          <h1 class="ls-leads-inbox--left-header">Conversations</h1>
          <div class="ls-leads-inbox--outer-wrapper">
            <div v-for="contact in contacts" :key="contact.id" class="ls-leads-inbox--crew-select">
              <div
                v-if="contact.id"
                :class="{
                  'ls-leads-inbox--selected': contact.id === selected_contact_id,
                }"
              >
                <LeadsMessageCrewSelectContactItem
                  :item="getContactProps(contact)"
                  @click="handleSelectContact"
                />
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <Transition name="conversation">
        <div
          v-if="(!screenSize.desktop && !isInbox) || screenSize.desktop"
          id="ls-leads-inbox-view--conversation"
          :class="[
            'ls-leads-inbox-view--conversation',
            { 'column is-8': screenSize.desktop, 'column is-12': !screenSize.desktop },
          ]"
        >
          <LeadsConversationMessages
            test-id="leads-conversation-messages"
            :messages="customerLeads.messages"
            :contact="getContactProps(getSelectedContact())"
            :contractor="getSelectedContact().contractor"
            @onSendMessage="handleSendMessage($event)"
            @onOpenConfirmHiredModal="handleOpenConfirmHiredModal($event)"
            @onBackToInbox="isInbox = true"
          />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import { lsRouterHelpers, lsModalService } from 'ls-vue-common';
import {
  CUSTOMER_LEADS__GET_MESSAGES,
  CUSTOMER_LEADS__SEND_MESSAGE,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
  PROPERTIES__GET_CUSTOMER_LEAD_BY_ID,
} from '@/store/types';
import { LeadsConfirmHiredModal } from '@/modals';
import LeadsConversationMessages from './LeadsConversation/LeadsConversationMessages.vue';
import LeadsMessageCrewSelectContactItem from '@/views/Authorized/Leads/LeadsInboxView/LeadsMessageCrewSelectItem/LeadsMessageCrewSelectContactItem.vue';

export default {
  name: 'LeadsInboxView',
  components: {
    LeadsMessageCrewSelectContactItem,
    LeadsConversationMessages,
  },
  data() {
    return {
      isLoading: true,
      selected_contact_id: null,
      customerLead: {},
      isInbox: false,
      readById: {},
    };
  },
  computed: {
    ...mapState(['properties', 'screenSize', 'customerLeads']),
    ...mapGetters({
      PROPERTIES__GET_CUSTOMER_LEAD_BY_ID,
    }),
    contacts() {
      return _.get(this.customerLead, 'customer_lead_contacts', []);
    },
    routeParams() {
      return {
        property_id: parseInt(lsRouterHelpers.getParam(this.$route, 'property_id', 0), 10),
        customer_lead_id: parseInt(
          lsRouterHelpers.getParam(this.$route, 'customer_lead_id', 0),
          10
        ),
        selected_contact_id: parseInt(lsRouterHelpers.getParam(this.$route, 'contact_id', 0), 10),
      };
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]({ forceRefresh: true });
    const { property_id, customer_lead_id, selected_contact_id } = this.routeParams;
    this.customerLead = this[PROPERTIES__GET_CUSTOMER_LEAD_BY_ID](property_id, customer_lead_id);
    this[CUSTOMER_LEADS__GET_MESSAGES]({
      property_id,
      customer_lead_id,
      contact_id: selected_contact_id,
    });

    this.selected_contact_id = selected_contact_id;
    this.readById[selected_contact_id] = true;

    this.isLoading = false;
  },
  methods: {
    ...mapActions([
      CUSTOMER_LEADS__GET_MESSAGES,
      CUSTOMER_LEADS__SEND_MESSAGE,
      PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
    ]),

    // Handles updating state after selecting a different contact
    async handleSelectContact(data) {
      const { property_id, customer_lead_id } = this.routeParams;
      this.$router.push({
        name: 'leadsInbox',
        params: {
          property_id,
          customer_lead_id,
          contact_id: data.id,
        },
      });
      this.selected_contact_id = data.id;
      this.readById[data.id] = true;
      this.isInbox = false;
      const params = { ...this.routeParams };
      params.contact_id = data.id;
      this[CUSTOMER_LEADS__GET_MESSAGES](params);
    },
    getContactProps(contact) {
      const firstName = _.get(contact, 'contractor.user.first_name', '');
      const lastName = _.get(contact, 'contractor.user.last_name', '');
      return {
        name: `${firstName} ${lastName}`,
        id: contact.id,
        contractorName: _.get(contact, 'contractor.name'),
        status: contact.status,
        isSelected: contact.id === this.selected_contact_id,
        is_unread: contact.is_unread && !this.readById[contact.id],
      };
    },
    getSelectedContact() {
      const selectedContactId = this.selected_contact_id
        ? this.selected_contact_id
        : this.routeParams.selected_contact_id;
      return _.find(this.contacts, { id: selectedContactId });
    },
    handleSendMessage(e) {
      const { message, images } = e;
      const { customer_lead_id, property_id } = this.routeParams;
      this[CUSTOMER_LEADS__SEND_MESSAGE]({
        customer_lead_id,
        property_id,
        contact_id: this.selected_contact_id,
        message,
        images,
      });
    },
    handleOpenConfirmHiredModal() {
      const contact = this.getSelectedContact();
      lsModalService.open({
        parent: this,
        component: LeadsConfirmHiredModal,
        props: {
          contractor: contact.contractor,
          customerLeadId: this.routeParams.customer_lead_id,
          contactId: contact.id,
          propertyId: this.routeParams.property_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-leads-inbox {
  padding: 0 0px 0 18px;
}

.ls-leads-inbox--outer-wrapper {
  width: 100%;
}

.inbox-enter-active,
.inbox-leave-active,
.conversation-enter-active,
.conversation-leave-active {
  transition: all 0.5s ease-in-out;
}

.inbox-enter,
.inbox-leave-to {
  opacity: 0;
  transform: translateX(-600px);
}

.conversation-enter,
.conversation-leave-to {
  opacity: 0;
  transform: translateX(600px);
}

.ls-leads-inbox--left {
  height: 85vh;
  position: absolute;
  border-right: 2px solid $primary-light;
}

.ls-leads-inbox--left-header {
  padding: 10px 10px 20px 10px;
}

.ls-leads-inbox--crew-select {
  width: 104%;
  padding: 6px 0;
  border-top: 2px solid $primary-light;
}

.ls-leads-inbox--selected {
  width: 100%;
  background-color: $primary-light;
  position: relative;
  &:after {
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid $primary-light;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    right: -15px;
    top: calc(50% - 15px);
  }
}

.ls-leads-inbox-view--conversation {
  height: 100%;
  position: absolute;
  left: 324px;
  top: 0px;
  padding-left: 20px;
}

.ls-leads-inbox-view--placholder-text {
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $size-4;
  color: $primary;
}

@media (max-width: $mobile-max-width) {
  .inbox-enter-active,
  .inbox-leave-active,
  .inbox-enter,
  .inbox-leave-to,
  .conversation-enter-active,
  .conversation-leave-active,
  .conversation-enter,
  .conversation-leave-to {
    // avoid awkward input box shift durring animation
    overflow-y: hidden;
  }

  .ls-leads-inbox--left {
    border-right: none;
  }

  .ls-leads-inbox--crew-select {
    width: 98%;
  }

  #ls-leads-inbox-view--conversation {
    height: 100%;
    left: 0;
    padding-left: 10px;
  }

  .ls-leads-inbox--selected {
    background-color: $primary-light;
    &:after {
      border: none;
      content: '';
    }
  }
}
.themed-app {
  .ls-leads-inbox--left {
    border-color: $theme-color-primary-light;
  }
  .ls-leads-inbox--crew-select {
    border-color: $theme-color-primary-light;
  }

  .ls-leads-inbox--selected {
    background-color: $theme-color-primary-light;
    &:after {
      border-left-color: $theme-color-primary-light;
    }
  }
  .ls-leads-inbox-view--placholder-text {
    font-size: $theme-txt-body-lg;
    color: $theme-color-primary;
  }
  @media (max-width: $mobile-max-width) {
    .ls-leads-inbox--selected {
      background-color: $theme-color-primary-light;
    }
  }
}
</style>
